// Dynamically load Hyper's blog/article-card CSS if not already present
function loadHyperBlogAssets() {
  [
    'component-article-card.css',
    'section-featured-blog.css'
  ].forEach(function(file) {
    if (!document.querySelector('link[href*="' + file + '"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = (window.Shopify?.assets?.[file]) || `/cdn/shop/t/6/assets/${file}`;
      document.head.appendChild(link);
    }
  });
}
loadHyperBlogAssets();

// Substack feed - matches Hyper's featured-blog / card-article structure
document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("custom-substack-feed");
  if (!container) return;

  const feedUrl = "https://api.rss2json.com/v1/api.json?rss_url=https://kirkbangstad.substack.com/feed";
  const fallbackImage = "https://placehold.co/600x600?text=Substack";

  fetch(feedUrl)
    .then(res => res.json())
    .then(data => {
      if (!data.items || !data.items.length) {
        container.innerHTML = "<p>No posts available.</p>";
        return;
      }

      const posts = data.items.slice(0, 3);

      const html = posts.map((post, idx) => {
        const imageMatch = post.content.match(/<img[^>]+src="([^">]+)"/i);
        const imageUrl = imageMatch ? imageMatch[1] : fallbackImage;
        const alt = post.title || 'Substack post image';

        let excerpt = post.content.replace(/<[^>]+>/g, "").trim();
        if (excerpt.length > 160) {
          excerpt = excerpt.substring(0, excerpt.lastIndexOf(" ", 157)) + "...";
        }

        const articleUrl = post.link;

        return `
<div class="f-column">
  <div class="article-card article-card--standard">
    <div class="article-card__media blocks-radius">
      <a href="${articleUrl}" class="block media-wrapper hover-wrapper" target="_blank" rel="noopener" aria-label="${alt}">
        <motion-element class="block" data-motion="zoom-out-sm" style="--aspect-ratio: 1;">
          <img src="${imageUrl}" alt="${alt}" loading="lazy" class="motion-reduce hover-scale-up" style="object-fit: cover;">
        </motion-element>
      </a>
    </div>
    <div class="article-card__content">
      <div class="article-card__content-inner">
        <h3 class="article-card__title h4">
          <a class="reversed-link" href="${articleUrl}" target="_blank" rel="noopener">${post.title}</a>
        </h3>
        <p class="article-card__excerpt text-limit-2-lines text-subtext">${excerpt}</p>
        <a href="${articleUrl}" class="btn btn--primary article-card__button" target="_blank" rel="noopener">
          <span class="btn__text">Read article</span>
        </a>
      </div>
    </div>
  </div>
</div>`;
      }).join("");

      container.innerHTML = `
<div class="section section--padding featured-blog color-scheme-1">
  <div class="section__container page-width page-width--fixed">
    <div class="section-heading section-heading--horizontal flex justify-between items-center" style="margin-bottom: 2rem;">
      <h2 class="section-heading__heading h3">Resistance News</h2>
      <a href="https://kirkbangstad.substack.com/" class="btn btn--primary" target="_blank" rel="noopener" aria-label="Read all">
        <span class="btn__text">Read all</span>
      </a>
    </div>
    <div class="featured-blog__wrapper f-grid--gap-medium f-grid--row-gap-medium" style="--f-columns-mobile: 1; --f-columns-md: 2; --f-columns-xl: 3;">
      <div class="featured-blog__items f-grid">
        ${html}
      </div>
    </div>
  </div>
</div>
      `;
    })
    .catch(error => {
      console.error("Error loading Substack feed:", error);
      container.innerHTML = "<p>Could not load posts.</p>";
    });
});